import React from "react";
import { LoadingIcon } from '@prosolve/common-components-ui'

export default ({
  backgroundColor,
  transparent,
  width,
  marginTop,
  marginLeft,
  message = ''
}) => {
  return (
    <div style={{ 
      position: 'fixed',
      width: width || '100%',
      height: '100%',
      top: '0px',
      left: '0px',
      background: backgroundColor || '#b8b8b8',
      opacity: transparent ? '0.72' : '1',
      zIndex: '100000',
      marginTop: marginTop || '0px',
      marginLeft: marginLeft || '0px',
    }}>
      <div style={{ 
        padding: '5px 5px',
        height: 'calc(100vh - 10px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <LoadingIcon />
        {
          Boolean(message) &&
          <div style={{ marginTop: '10px' }}>
            {message}
          </div>
        }
      </div>
    </div>
  )
}